import axiosInstance from "@/lib/axios";
import type { PreparedPdf } from "./buildReportPdf";

/** Server: core/reports/v2/share (store the PDF, mint a signed 7-day link). */
export const reportShareEndpoint = "/core/reports/v2/share";

export interface ReportShareLink {
  url: string;
  expiresAt: string;
  fileName: string;
}

export async function uploadReportPdf(pdf: PreparedPdf): Promise<ReportShareLink> {
  const form = new FormData();
  form.append("file", new File([pdf.blob], pdf.fileName, { type: "application/pdf" }));
  form.append("fileName", pdf.fileName);
  const res = await axiosInstance.post(reportShareEndpoint, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const data = res.data?.data as ReportShareLink | undefined;
  if (!data?.url) throw new Error("The server did not return a link.");
  return data;
}

export function apiErrorText(error: unknown, fallback: string): string {
  const e = error as { response?: { status?: number; data?: { message?: string } }; message?: string };
  if (e?.response?.status === 404) return "Sharing links aren't available on this server yet.";
  return e?.response?.data?.message || e?.message || fallback;
}
